import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { API_URL } from '../config/constants';

const AUTHORIZATION_HEADER = 'Bearer 8e0b79e8da08fe46977c60803f2c0771a3090eabad89b1fc7000e48dc96b0cbfe51de7a0f74c273ed32a62930c7fe27fd0f23d628298ea6ac285d50ce0b9a53e245f1c43f663d1893a070c154c9ee1c3de8aee523bdb4a14743c16966818a3ef37322aa5ccdcfc0fdde0187fb1578ce542cfe3b1af7f8faf552b9412f8162eca'

export const baseQuery = () => fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers) => {
        headers.set('authorization', AUTHORIZATION_HEADER)
        headers.set('Accept-Language', 'ru-RU')

        return headers
    },
})
